import { HttpClientModule } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { QrcodeComponent } from './qrcode/qrcode.component';
import { DidDocComponent } from './did-doc/did-doc.component';
import { VisComponent } from './vis/vis.component';
import { VisMapComponent } from './vis/vis-map/vis-map.component';
import { VisDetailComponent } from './vis/vis-detail/vis-detail.component';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GoogleMapsModule } from '@angular/google-maps';
import { MaterialModule } from './material-module';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    QrcodeComponent,
    DidDocComponent,
    VisComponent,
    VisMapComponent,
    VisDetailComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxChartsModule,
    NgxGraphModule,
    BrowserAnimationsModule,
    GoogleMapsModule,
    MaterialModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
